import { render } from "./Tianjiashoufukuan.vue?vue&type=template&id=e5b20024&scoped=true"
import script from "./Tianjiashoufukuan.vue?vue&type=script&lang=js"
export * from "./Tianjiashoufukuan.vue?vue&type=script&lang=js"

import "./Tianjiashoufukuan.vue?vue&type=style&index=0&id=e5b20024&lang=scss&scoped=true"

import exportComponent from "D:\\svn_gongzuo\\_____base\\GoPay\\v3_gopay\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5b20024"]])

export default __exports__